/**
* @license Apache-2.0
*
* Copyright (c) 2024 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //

import setReadOnly from '@stdlib/utils/define-read-only-property';


// MAIN //

/**
* Top-level namespace.
*
* @namespace ns
*/
var ns = {};

/**
* @name isAlmostEqual
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/complex/float32/base/assert/is-almost-equal}
*/
import isAlmostEqual from './../../../../float32/base/assert/is-almost-equal';
setReadOnly( ns, 'isAlmostEqual', isAlmostEqual );

/**
* @name isAlmostSameValue
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/complex/float32/base/assert/is-almost-same-value}
*/
import isAlmostSameValue from './../../../../float32/base/assert/is-almost-same-value';
setReadOnly( ns, 'isAlmostSameValue', isAlmostSameValue );

/**
* @name isEqual
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/complex/float32/base/assert/is-equal}
*/
import isEqual from './../../../../float32/base/assert/is-equal';
setReadOnly( ns, 'isEqual', isEqual );

/**
* @name isNotEqual
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/complex/float32/base/assert/is-not-equal}
*/
import isNotEqual from './../../../../float32/base/assert/is-not-equal';
setReadOnly( ns, 'isNotEqual', isNotEqual );

/**
* @name isSameValue
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/complex/float32/base/assert/is-same-value}
*/
import isSameValue from './../../../../float32/base/assert/is-same-value';
setReadOnly( ns, 'isSameValue', isSameValue );

/**
* @name isSameValueZero
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/complex/float32/base/assert/is-same-value-zero}
*/
import isSameValueZero from './../../../../float32/base/assert/is-same-value-zero';
setReadOnly( ns, 'isSameValueZero', isSameValueZero );


// EXPORTS //

export default ns;
